<template>
    <!-- eslint-disable vue/no-useless-template-attributes -->
    <div class="promotion-maintenance">
        <div class="promotion-maintenance__content" :class="isParkingLot ? '' : '.non-parkinglot'">
            <v-form ref="promotion-maintenance-form" v-model="validation.isValid" @submit.prevent>
                <v-tabs
                    v-model="selectedTab"
                    height="2.5rem"
                    background-color="transparent"
                    class="promo-tabs"
                    active-class="promo-tabs__tab--active"
                    hide-slider
                    @update:model-value="navigateToTab"
                >
                    <template v-for="tab in tabs" :key="'tab' + tab.tabName" :value="tab">
                        <v-tab :disabled="tab.disabled" class="promo-tabs__tab">
                            <v-tooltip v-if="tab.disabled" z-index="400" top>
                                <template v-slot:activator="{ props }">
                                    <span v-bind="props">
                                        {{ toSentenceCase($t(tab.label)) }}
                                    </span>
                                </template>
                                <span v-if="disabledTabTooltip">{{
                                    $t(`planning.promotionsViewer.${disabledTabTooltip}`)
                                }}</span>
                            </v-tooltip>

                            <template v-else>
                                {{ toSentenceCase($t(tab.label)) }}
                                <div v-if="getTabState(tab) !== tabStates.invalid">
                                    <icon
                                        v-if="
                                            getTabState(tab) === tabStates.notStarted ||
                                                getTabState(tab) === tabStates.inProgress
                                        "
                                        icon-name="custom:empty-success-circle"
                                        small
                                    />
                                    <icon
                                        v-else-if="getTabState(tab) === tabStates.completed"
                                        icon-name="custom:success-circle"
                                        small
                                    />
                                </div>
                            </template>
                        </v-tab>
                        <!-- Used to fill and style the space between tabs. -->
                        <div class="promo-tabs__spacer" />
                    </template>
                    <div class="promo-tabs__tab-button-spacer" />
                    <div class="promo-tabs__tab-button">
                        <split-promotion
                            v-if="promotionForForecasting.splitPromotion"
                            :promotion-id="selectedPromotionId"
                            :product-count="promotionForForecasting.products.length"
                            :disabled="isSplitButtonDisabled"
                            @split-requested="$emit('split-requested')"
                        />
                    </div>
                    <div class="promo-tabs__tab-button-spacer" />
                    <div class="promo-tabs__tab-button">
                        <task-button
                            v-if="
                                !isParkingLotOrSubCampaignTab &&
                                    scenario &&
                                    scenario.isFavourite &&
                                    !toggleLogic[showPromotionWorkflowIcon]
                            "
                            :task="workflowTasks.submit"
                            :entity-type="workflowEntities.promotion"
                            :entity-ids="[selectedPromotionId]"
                            :sub-campaign-id="scenario.subCampaignId"
                            :show-action-date-time="true"
                            :categories="promotion.userSelectedCategories || []"
                            :is-store-wide-promotion="isStoreWidePromotion"
                            :disabled="isTaskButtonsDisabled"
                            :disabled-reason="actionsDisabledReason"
                            short-text
                            @click="
                                () => {
                                    setIsActionDisabled(true);
                                }
                            "
                            @action-completed="
                                () => {
                                    setIsActionDisabled(false);
                                }
                            "
                        />
                    </div>
                    <!-- Used to fill and style the remaining space from the last tab to the end of the tabs container. -->
                    <div class="promo-tabs__filler" />
                    <div v-if="isMakeStandardPromotionBtnVisible" class="promo-tabs__tab-button">
                        <confirm-dialog
                            class="confirm-dialog"
                            :question-text="
                                $t('planning.promotionsViewer.makeStandardQuestionText')
                            "
                            :warning-text="$t('planning.promotionsViewer.makeStandardWarningText')"
                            :action-text="$t('planning.promotionsViewer.makeStandardActionText')"
                            @confirm="onMakeStandardPromotionBtnClick"
                        >
                            <template v-slot:actions="{ activator }">
                                <v-btn
                                    v-bind="activator"
                                    class="make-standard-btn"
                                    :disabled="isMakeStandardPromotionBtnDisabled"
                                    primary
                                    depressed
                                >
                                    {{ $t('planning.promotionsViewer.makeStandardActionText') }}
                                </v-btn>
                            </template>
                        </confirm-dialog>
                    </div>
                    <div v-if="isPublishingModeBtnVisible" class="promo-tabs__tab-button">
                        <feature-toggle :toggle="canUpdatePromotionPublishingMode">
                            <v-tooltip
                                :text="publishingModeBtnDisabledReason"
                                location="bottom"
                                :disabled="!publishingModeBtnDisabledReason"
                            >
                                <template v-slot:activator="{ props }">
                                    <span v-bind="props">
                                        <simple-button
                                            :disabled="isPublishingModeBtnDisabled"
                                            @click="openMakeManualConfirmation"
                                        >
                                            {{ publishingModeBtnText }}
                                        </simple-button>
                                    </span>
                                </template>
                            </v-tooltip>
                            <confirm-dialog
                                ref="make-manual-confirmation-dialog"
                                class="confirm-dialog"
                                :question-text="
                                    $t('planning.promotionsViewer.makeManualQuestionText')
                                "
                                :warning-text="
                                    $t('planning.promotionsViewer.makeManualWarningText')
                                "
                                :action-text="publishingModeBtnText"
                                :has-activator="false"
                                @confirm="onPublishingModeBtnCLick"
                            />
                        </feature-toggle>
                    </div>
                    <task-buttons-dropdown
                        v-if="
                            !isParkingLotOrSubCampaignTab &&
                                scenario &&
                                scenario.isFavourite &&
                                !toggleLogic[showPromotionWorkflowIcon]
                        "
                        :tasks="workflowTasksList"
                        :entity-type="workflowEntities.promotion"
                        :entity-ids="[selectedPromotionId]"
                        :sub-campaign-id="scenario.subCampaignId"
                        :entity-instance="promotion"
                        :categories="promotion.userSelectedCategories || []"
                        :is-store-wide-promotion="isStoreWidePromotion"
                        :is-disabled="isTaskButtonsDisabled"
                        :disabled-reason="actionsDisabledReason"
                        @click="
                            () => {
                                setIsActionDisabled(true);
                            }
                        "
                        @action-completed="
                            () => {
                                setIsActionDisabled(false);
                            }
                        "
                    />
                    <div
                        v-if="generalConfig.showWorkflowDebugIcon"
                        class="promo-tabs__notifications-icon"
                    >
                        <workflow-state
                            v-if="!isParkingLotOrSubCampaignTab"
                            :entity-id="selectedPromotionId"
                            :workflow-entity="workflowEntities.promotion"
                        />
                    </div>

                    <div class="promo-tabs__notifications-icon">
                        <notes
                            :notes="notes"
                            :disabled="!editContext"
                            open-left
                            @delete="removeNote"
                            @post="postNote"
                            @save="saveNote"
                        />
                    </div>
                </v-tabs>

                <v-tabs-window v-model="selectedTab">
                    <v-tabs-window-item
                        v-for="(tab, ix) in tabs"
                        :key="'tab-item-' + ix"
                        :transition="false"
                        :reverse-transition="false"
                    >
                        <alert-banner
                            v-if="isReadOnly && !pendingChangesToReview"
                            :reason="propagatedReadOnlyReason"
                            class="ml-4"
                        />
                        <review-changes-dialog
                            v-if="pendingChangesToReview"
                            :promotion-id="namespace"
                            :ignore-parent-read-only="ignoreReadonlyForReviewChanges"
                            :live-disabled="!isPendingChnagesBtnAvailable"
                            :promotion-editing-state="promotionEditingState"
                        />
                        <div v-if="tab.component">
                            <component
                                :is="tab.component"
                                :context="customContext"
                                :form-ref="formRef"
                                :edit-mode="editMode"
                                :namespace="namespace"
                                :is-new-promotion="isNewPromotion"
                                :is-sub-campaign-allocation="isSubCampaignAllocation"
                                :promotion-editing-state="promotionEditingState"
                                :is-parking-lot="isParkingLot"
                                :is-past-promotions="isPastPromotions"
                                :cache-dom="tab.cacheDOM"
                                :pending-changes-to-review="pendingChangesToReview"
                                :show-price-tag-gallery="showPriceTagGallery"
                            />
                        </div>
                        <h1 v-else>{{ tab.content }}</h1>
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-form>
            <v-divider />

            <div class="footer">
                <div class="footer__execution">
                    <feature-toggle :toggle="canManuallyValidatePromotion">
                        <v-tooltip
                            :text="actionsDisabledReason"
                            location="bottom"
                            :disabled="!actionsDisabledReason"
                        >
                            <template v-slot:activator="{ props }">
                                <span v-bind="props">
                                    <v-btn
                                        :ignore-parent-read-only="canValidate"
                                        :disabled="isTaskButtonsDisabled"
                                        primary
                                        depressed
                                        class="ma-1"
                                        @click="validatePromotion"
                                    >
                                        {{
                                            toSentenceCase(
                                                $t('execution.actions.validatePromotion')
                                            )
                                        }}
                                    </v-btn>
                                </span>
                            </template>
                        </v-tooltip>
                    </feature-toggle>
                    <feature-toggle :toggle="canManuallyExecutePromotion">
                        <v-tooltip
                            :text="actionsDisabledReason"
                            location="bottom"
                            :disabled="!actionsDisabledReason"
                        >
                            <template v-slot:activator="{ props }">
                                <span v-bind="props">
                                    <v-btn
                                        v-if="!isParkingLot && scenario && scenario.isFavourite"
                                        :disabled="isTaskButtonsDisabled"
                                        primary
                                        depressed
                                        class="ma-1"
                                        @click="executePromotion"
                                    >
                                        {{
                                            toSentenceCase($t('execution.actions.executePromotion'))
                                        }}
                                    </v-btn>
                                </span>
                            </template>
                        </v-tooltip>
                    </feature-toggle>
                </div>
                <div class="footer__forecast-save-container">
                    <unsaved-banner
                        small
                        class="footer__unsaved"
                        :promotion-id="selectedPromotionId"
                    />
                    <div
                        v-if="isPromotionSaveInProgress"
                        class="footer__forecast-save-container__spinner"
                    >
                        <spinner-dynamic />
                    </div>
                    <simple-button
                        v-if="isPromotionUnsaved"
                        :disabled="isPromotionSaveInProgress"
                        light-theme
                        class="mr-2"
                        @click="cancelChanges"
                    >
                        {{ toSentenceCase($t('actions.cancel')) }}
                    </simple-button>
                    <positive-action-button
                        :disabled="
                            isSavePromotionDisabled ||
                                isPromotionSaveInProgress ||
                                attributeScopePromoDisabledSave
                        "
                        :ignore-parent-read-only="ignoreParentReadOnlyFlag"
                        @on-click="forecastAndSavePromotionHandler"
                    >
                        {{ toSentenceCase($t('planning.buttons.forecastAndSavePromotion')) }}
                    </positive-action-button>
                </div>
            </div>
        </div>
        <div class="promotion-maintenance__sidebar">
            <promotion-forecasting
                :promotion="promotionForForecasting"
                :is-past-promotions="isEffectivelyPastPromotion"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import { sortBy, findIndex, get, isEmpty, find, isNil } from 'lodash';
import NotesFieldKeys from '@enums/notes-field-keys';
import workflowTasks from '@enums/workflow-tasks';
import workflowEntities from '@enums/workflow-entities';
import lockedReasons from '@enums/locked-reasons';
import UXEvents from '@enums/ux-events';
import TabStates from '@enums/tab-states';
import tabsEnum from '@enums/promotion-tabs';
import workflowStates from '@enums/workflow-states';
import promotionTypes from '@enums/promotion-types';
import featureFlags from '@enums/feature-flags';
import fundingUtils from '@sharedModules/funding-utils';
import promotionUtils from '@sharedModules/promotion-utils';
import { toSentenceCase } from '@/js/utils/string-utils';
import namespaces from '@enums/namespaces';
import navigation from '@/js/navigation';
import vuexFormMixin from '@/js/mixins/vuex-form';

const SESSION_TAB_KEY_PREFIX = 'promotion-maintenance.selectedTab.';

const {
    enablePromotionPermalink,
    promotionNameIsRequired,
    canEditPromotion,
    canManuallyExecutePromotion,
    canManuallyValidatePromotion,
    canCreateSplitPromotion,
    canUpdatePromotionPublishingMode,
    canApplyChangesForLivePromotions,
    showPromotionWorkflowIcon,
} = featureFlags;

export default {
    mixins: [vuexFormMixin],
    props: {
        promotion: {
            required: true,
            type: Object,
        },
        scenario: {
            required: true,
            type: Object,
        },
        isNewPromotion: {
            type: Boolean,
            default: false,
        },
        isParkingLot: {
            type: Boolean,
            default: false,
        },
        isSubCampaignAllocation: {
            type: Boolean,
            default: false,
        },
        promotionEditingState: {
            type: Object,
            required: true,
        },
        isPastPromotions: {
            type: Boolean,
            default: false,
        },
        showPriceTagGallery: {
            type: Boolean,
            default: true,
        },
        changeset: {
            type: Object,
            default: null,
        },
    },
    emits: ['split-requested', 'save-button-clicked'],
    data() {
        return {
            tabStates: TabStates,
            workflowTasks,
            workflowEntities,
            workflowTasksList: [
                {
                    task: workflowTasks.approve,
                    isNegativeAction: false,
                },
                {
                    task: workflowTasks.approve,
                    isNegativeAction: true,
                },
            ],
            formRef: null,
            selectedTab: null,
            canManuallyExecutePromotion,
            canManuallyValidatePromotion,
            isManualSaveInProgress: false,
            isActionsDisabled: false,
            isExecutionInProgress: false,
            showNewFundingViewer: true,
            canUpdatePromotionPublishingMode,
            showPromotionWorkflowIcon,
            isMoveInManualModBtnDisabled: false,
            makeStandardInProgress: false,
        };
    },
    events: {
        // when promotions are updated in store we need to update staging area
        onPromotionsUpdated() {
            this.populateFieldsInStagingArea();
        },
        toggleFundingView() {
            this.showNewFundingViewer = !this.showNewFundingViewer;
        },
        onPromotionForecastedAndSaved({ forecastResult }) {
            this.postSaveActions(forecastResult);
        },
        onForecastAndSavePromotion() {
            this.forecastAndSavePromotion();
        },
    },
    computed: {
        ...mapState('clientConfig', ['generalConfig', 'toggleLogic', 'promotionTabs']),
        ...mapState('rateCards', ['selectedRateCardIdForSplitting']),
        ...mapGetters('promotions', [
            'getStagingAreaPromotionById',
            'pendingChanges',
            'getPromotionNotifications',
            'isSelectedPromotionStoreWide',
            'isSelectedPromotionCategoryWide',
            'isSelectedPromotionCategoryOrStoreWide',
            'getParentPromotionsKeyedById',
            'selectedPromotion',
        ]),
        ...mapState('promotions', [
            'tabValidationState',
            'unsavedPromotion',
            'saveInProgress',
            'addProductInProgress',
            'attributeFilterInvalid',
        ]),
        tabs() {
            const promoTabs = [
                {
                    label: this.promotionTabs.date.name,
                    component: 'promotion-dates-form-wrapper',
                    tabName: tabsEnum.date,
                    position: this.promotionTabs.date.position,
                    isDefault: this.promotionTabs.date.isDefault,
                    cacheDOM: this.promotionTabs.date.cacheDOM,
                    disabled: this.isPromotionUnsaved,
                    visible: this.promotionTabs.date.visible,
                },
                {
                    label: this.promotionTabs.channels.name,
                    component: 'channels-stores-form-wrapper',
                    tabName: tabsEnum.channels,
                    position: this.promotionTabs.channels.position,
                    isDefault: this.promotionTabs.channels.isDefault,
                    cacheDOM: this.promotionTabs.channels.cacheDOM,
                    disabled: this.isPromotionUnsaved,
                    visible: this.promotionTabs.channels.visible,
                },
                {
                    label: this.promotionTabs.offer.name,
                    component: 'offer-form-wrapper',
                    tabName: tabsEnum.offer,
                    position: this.promotionTabs.offer.position,
                    isDefault: this.promotionTabs.offer.isDefault,
                    cacheDOM: this.promotionTabs.offer.cacheDOM,
                    disabled: this.isPromotionUnsaved,
                    visible: this.promotionTabs.offer.visible,
                },
                {
                    label: this.promotionTabs.funding.name,
                    component: 'funding-form-wrapper',
                    tabName: tabsEnum.funding,
                    position: this.promotionTabs.funding.position,
                    isDefault: this.promotionTabs.funding.isDefault,
                    cacheDOM: this.promotionTabs.funding.cacheDOM,
                    disabled:
                        this.isSelectedPromotionCategoryOrStoreWide || this.isPromotionUnsaved,
                    visible: this.promotionTabs.funding.visible,
                },
                {
                    label: this.promotionTabs.supply.name,
                    component: 'supply-form-wrapper',
                    tabName: tabsEnum.supply,
                    position: this.promotionTabs.supply.position,
                    isDefault: this.promotionTabs.supply.isDefault,
                    cacheDOM: this.promotionTabs.supply.cacheDOM,
                    disabled:
                        this.isSelectedPromotionCategoryOrStoreWide ||
                        this.isEmptyDates ||
                        this.isPromotionUnsaved,
                    visible: this.promotionTabs.supply.visible,
                },
            ];
            const filteredTabs = promoTabs.filter(tab => tab.visible);
            return sortBy(filteredTabs, 'position');
        },

        disabledTabTooltip() {
            if (this.isStoreWidePromotion) {
                return 'disabledForStoreWide';
            }
            if (this.isCategoryWidePromotion) {
                return 'disabledForCategoryWide';
            }
            if (this.isEmptyDates) {
                return 'emptyDates';
            }

            if (this.isPromotionUnsaved) {
                return 'unsavedPromotion';
            }

            return null;
        },

        isParkingLotOrSubCampaignTab() {
            return this.isParkingLot || this.isSubCampaignAllocation;
        },

        isPromotionUnsaved() {
            const tabValues = Object.values(this.unsavedPromotion[this.selectedPromotionId] || {});
            return tabValues.filter(v => v).length > 0;
        },

        isEmptyDates() {
            return !this.promotionForForecasting.startDate || !this.promotionForForecasting.endDate;
        },

        promotionForForecasting() {
            // copying promotion in stagingArea and retain other fields
            return {
                ...this.promotion,
                ...this.getStagingAreaPromotionById(this.selectedPromotionId || 'default'),
            };
        },

        customContext() {
            return {
                selectedScenario: this.scenario,
                selectedPromotion: this.promotion,
            };
        },

        notes() {
            return sortBy(this.promotion.notes, 'createdOn');
        },

        selectedPromotionId() {
            return this.computedNamespace;
        },

        canValidate() {
            return this.isParkingLot && this.toggleLogic[canEditPromotion];
        },

        isSavePromotionDisabled() {
            const stagingAreaPromotion = this.getStagingAreaPromotionById(
                this.selectedPromotionId || 'default'
            );
            const { channels } = tabsEnum;
            const tabsInvalid = this.getTabState({ tabName: channels }) !== TabStates.completed;
            const categories = get(stagingAreaPromotion, 'userSelectedCategories', []);
            const hasCategoriesOrIsStoreWidePromo =
                !!categories.length || this.isStoreWidePromotion;
            const rateCards = get(stagingAreaPromotion, 'rateCards', []);
            const hasIncompleteRateCards = rateCards.some(rc => isNil(rc._id) || isNil(rc.amount));
            // Note: validation.isValid can be null during v-form validation cycles
            // (e.g. when form children are destroyed/added), so we check explicitly
            // for false rather than just falsy to avoid the button flickering disabled.
            return (
                this.validation.isValid === false ||
                hasIncompleteRateCards ||
                tabsInvalid ||
                !this.toggleLogic[canEditPromotion] ||
                (this.toggleLogic[promotionNameIsRequired] && !this.promotionForForecasting.name) ||
                // validation for each tab happens only after tab open
                // we don't have defaults values for dates tab, this condition cover dates tab
                (!stagingAreaPromotion.startDate && !stagingAreaPromotion.endDate) ||
                (!stagingAreaPromotion._id && !hasCategoriesOrIsStoreWidePromo) ||
                this.isManualSaveInProgress ||
                this.addProductInProgress ||
                // Prevent saving while a rate card split is pending (user must click Add to total first)
                !!this.selectedRateCardIdForSplitting ||
                (this.showNewFundingViewer && !this.isNewPromotion && !this.isPromotionUnsaved)
            );
        },
        ignoreParentReadOnlyFlag() {
            return fundingUtils.getIgnoreReadOnlyFlag({
                selectedPromotion: this.selectedPromotion,
                toggleLogic: this.toggleLogic,
                promotionEditingState: this.promotionEditingState,
            });
        },

        pendingChangesToReview() {
            // Check for pending notifications in promotion without a changeset, which means this is post-redesign
            const hasChangesToReview = this.pendingChanges({
                promotionId: this.namespace,
            });

            return !(this.changeset || !hasChangesToReview);
        },

        isLivePromotion() {
            if (!this.selectedPromotionId) {
                return false;
            }
            const now = new Date();
            const startDate = new Date(this.promotionForForecasting.startDate);
            return startDate <= now;
        },
        isPendingChnagesBtnAvailable() {
            if (!this.isLivePromotion) {
                return this.pendingChangesToReview;
            }
            return (
                this.pendingChangesToReview && this.toggleLogic[canApplyChangesForLivePromotions]
            );
        },

        isStoreWidePromotion() {
            return this.isSelectedPromotionStoreWide;
        },

        isCategoryWidePromotion() {
            return this.isSelectedPromotionCategoryWide;
        },

        ignoreReadonlyForReviewChanges() {
            return this.propagatedReadOnlyReason === lockedReasons.promotionNotificationExist;
        },

        // isPastPromotions is a prop manually set by the parent based on the page/grid context
        // (e.g. the "past promotions" tab), not on the promotion's actual end date, so it can be
        // stale or wrong outside that context. Fall back to the real date-based check as well.
        isEffectivelyPastPromotion() {
            return (
                this.isPastPromotions ||
                promotionUtils.isPromotionPastEndDate({
                    moment: this.$moment,
                    endDate: this.promotion?.endDate,
                })
            );
        },

        actionsDisabledReason() {
            if (this.isPromotionUnsaved) {
                return toSentenceCase(this.$t(lockedReasons.promotionUnSaved));
            }

            if (this.promotion.splitPromotion) {
                return toSentenceCase(this.$t(lockedReasons.splitPromotion));
            }
            if (this.isEffectivelyPastPromotion) {
                return toSentenceCase(this.$t(lockedReasons.promotionPastEndDate));
            }
            if (this.isReadOnly && this.pendingChangesToReview) {
                return toSentenceCase(this.$t(lockedReasons.promotionNotificationExist));
            }

            return null;
        },

        isPromotionSaveInProgress() {
            return this.isManualSaveInProgress || this.saveInProgress;
        },

        isSplitButtonDisabled() {
            return (
                this.isActionsDisabled ||
                this.isExecutionInProgress ||
                this.isPromotionUnsaved ||
                !this.promotion._id ||
                this.promotion.splitInProgress ||
                isEmpty(this.promotion.products) ||
                this.promotion.products.length < this.generalConfig.minProductsPerSplitPromotion ||
                !this.toggleLogic[canCreateSplitPromotion]
            );
        },

        isTaskButtonsDisabled() {
            return (
                this.isActionsDisabled ||
                this.isExecutionInProgress ||
                this.isPromotionUnsaved ||
                this.promotion.splitPromotion ||
                this.isReadOnly
            );
        },
        isPublishingModeBtnVisible() {
            return get(this.promotion, 'parentPromotionId') && !this.promotion.isGhost;
        },
        isPublishingModeBtnDisabled() {
            const parentPromotionId = get(this.promotion, 'parentPromotionId', null);
            if (!parentPromotionId) return false;

            const parentPromotion = this.getParentPromotionsKeyedById[parentPromotionId] || {};

            const parentPromotionWorkflowState = parentPromotion.workflowState;
            const hasBeenApproved = find(parentPromotionWorkflowState, {
                entity: workflowEntities.promotion,
                state: workflowStates.hasBeenApproved,
                value: true,
            });

            return (
                !hasBeenApproved ||
                get(this.promotion, 'isInManualMode') ||
                this.isMoveInManualModBtnDisabled ||
                this.isEffectivelyPastPromotion
            );
        },
        publishingModeBtnText() {
            return this.$t('planning.buttons.makeManual');
        },
        publishingModeBtnDisabledReason() {
            const parentPromotionId = get(this.promotion, 'parentPromotionId', null);
            if (!parentPromotionId || !this.isPublishingModeBtnDisabled) return null;

            const parentPromotion = this.getParentPromotionsKeyedById[parentPromotionId] || {};
            const hasBeenApproved = find(parentPromotion.workflowState, {
                entity: workflowEntities.promotion,
                state: workflowStates.hasBeenApproved,
                value: true,
            });

            if (this.isEffectivelyPastPromotion) {
                return toSentenceCase(this.$t(lockedReasons.promotionPastEndDate));
            }
            if (get(this.promotion, 'isInManualMode')) {
                return toSentenceCase(this.$t(lockedReasons.promotionAlreadyInManualMode));
            }
            if (!hasBeenApproved) {
                return toSentenceCase(this.$t(lockedReasons.promotionParentNotApproved));
            }

            return null;
        },
        isMakeStandardPromotionBtnVisible() {
            return (
                this.namespace !== 'default' &&
                this.promotion.promotionType === promotionTypes.attributeScoped
            );
        },
        isMakeStandardPromotionBtnDisabled() {
            return (
                this.isManualSaveInProgress ||
                this.addProductInProgress ||
                this.isPromotionUnsaved ||
                this.isReadOnly ||
                this.makeStandardInProgress
            );
        },
        attributeScopePromoDisabledSave() {
            if (
                this.promotion.promotionType !== promotionTypes.attributeScoped ||
                isNil(this.attributeFilterInvalid[this.namespace]) ||
                this.tabs[this.selectedTab].tabName !== tabsEnum.offer
            ) {
                return false;
            }
            return !this.attributeFilterInvalid[this.namespace];
        },
    },
    watch: {
        $route() {
            this.setSelectedTab();
        },
    },
    created() {
        if (this.isParkingLotOrSubCampaignTab) {
            try {
                const key =
                    SESSION_TAB_KEY_PREFIX + (this.selectedPromotionId || this.computedNamespace);
                const stored = sessionStorage.getItem(key);
                if (stored !== null) {
                    const idx = Number(stored);
                    this.selectedTab = idx;
                    sessionStorage.removeItem(key);
                } else {
                    this.setSelectedTab();
                }
            } catch (e) {
                // sessionStorage may be unavailable in some environments; ignore errors
            }
        } else {
            this.setSelectedTab();
        }
    },
    async mounted() {
        // Hold a reference to the promotion maintenance form. This can be passed to child components to facilitate
        // running actions on the form from nested components, e.g. validation.
        this.formRef = this.$refs['promotion-maintenance-form'];

        // planning promotion call this action on expand event
        await this.updateDataForPromotion(this.promotionForForecasting);
    },
    methods: {
        ...mapActions('promotions', [
            'addNote',
            'deleteNote',
            'updateNote',
            'updateDataForPromotion',
            'setSelectedPromotion',
            'updatePromoPublishingMode',
            'updatePromotion',
            'setStagingAreaFields',
        ]),
        ...mapMutations('promotions', [
            'setSelectedPromotionMaintenanceTab',
            'setUnsavedPromotion',
        ]),
        ...mapActions('execution', ['validateSinglePromotionById', 'executeSinglePromotionById']),
        ...mapActions('forecasting', ['forecastSinglePromotion']),
        async forecastAndSavePromotionHandler() {
            // For attribute-scoped promotions, we need to call saveAttributeScopePromotion:
            // 1. When on the offer tab (where attribute filters are edited)
            // 2. OR when the promotion is not yet saved (namespace === 'default'),
            //    because unsaved promotions allow switching tabs without saving first
            const isOnOfferTab =
                this.selectedTab !== null &&
                this.tabs[this.selectedTab] &&
                this.tabs[this.selectedTab].tabName === tabsEnum.offer;
            const isUnsavedPromotion = this.computedNamespace === namespaces;

            // Use promotionForForecasting to get promotionType as it merges the staging area
            // which contains the type for new promotions
            if (
                this.promotionForForecasting.promotionType === promotionTypes.attributeScoped &&
                (isOnOfferTab || isUnsavedPromotion)
            ) {
                this.emitter.emit('forecast-and-save-attribute-scoped-promotion');
            } else {
                await this.forecastAndSavePromotion();
            }
        },
        async forecastAndSavePromotion() {
            if (this.isReadOnly && !this.ignoreParentReadOnlyFlag) return;
            this.isManualSaveInProgress = true;

            // Newly created promos should be saved before forecasting
            if (
                this.computedNamespace === namespaces ||
                this.isSelectedPromotionCategoryOrStoreWide
            ) {
                const saveResult = await this.submit();
                this.postSaveActions(saveResult);
                return saveResult;
            }

            this.isManualSaveInProgress = false;
            return this.forecastSinglePromotion({
                promotion: this.promotionForForecasting,
                callbackEvent: UXEvents.promotionForecastedAndSaved,
            });
        },

        async cancelChanges() {
            this.populateFieldsInStagingArea();
            const promotionId = this.selectedPromotionId;
            const currentTab = this.selectedTab;
            if (this.isParkingLotOrSubCampaignTab) {
                try {
                    const key = SESSION_TAB_KEY_PREFIX + (promotionId || this.computedNamespace);
                    sessionStorage.setItem(key, String(currentTab));
                } catch (e) {
                    // ignore sessionStorage errors
                }
            }
            await this.setSelectedPromotion({ promotionId });
            this.setUnsavedPromotion({ namespace: promotionId, tab: 'all', value: false });
            this.emitter.emit(UXEvents.resetPromotionViewerDialog, { currentTab, promotionId });
        },

        postSaveActions({ error, result }) {
            if (!error) {
                let globalEvent;
                if (this.computedNamespace === namespaces) {
                    // if new entity is created
                    globalEvent = this.isParkingLot
                        ? UXEvents.parkingLotCreated
                        : UXEvents.promotionCreated;
                } else {
                    // if entity is updated
                    globalEvent = this.isParkingLot
                        ? UXEvents.parkingLotSaved
                        : UXEvents.promotionSaved;
                }

                if (this.isParkingLotOrSubCampaignTab) {
                    // namespace required for some global event handlers e.g. updateOfferMechanicDescription
                    result.namespace = this.computedNamespace;
                }

                this.emitter.emit(globalEvent, result);
                // if promotion is viewed via dialog we handle it's closure
                if (this.isParkingLotOrSubCampaignTab) {
                    this.$emit('save-button-clicked', result);
                }

                this.setUnsavedPromotion({
                    namespace: this.selectedPromotionId,
                    tab: 'all',
                    value: false,
                });
            } else if (this.isParkingLotOrSubCampaignTab) {
                this.emitter.emit(UXEvents.parkingLotPromoSaveFailed);
            }

            this.isManualSaveInProgress = false;
        },

        validatePromotion() {
            this.validateSinglePromotionById({ namespace: this.selectedPromotionId });
        },

        async executePromotion() {
            this.isExecutionInProgress = true;
            await this.executeSinglePromotionById({ namespace: this.selectedPromotionId });
            this.isExecutionInProgress = false;
        },

        postNote(note) {
            this.addNote({
                note,
                id: this.selectedPromotionId,
                fieldKey: NotesFieldKeys.root,
            });
        },
        removeNote(noteId) {
            this.deleteNote({
                noteId,
                id: this.selectedPromotionId,
                fieldKey: NotesFieldKeys.root,
            });
        },
        saveNote(note) {
            this.updateNote({
                note,
                id: this.selectedPromotionId,
                fieldKey: NotesFieldKeys.root,
            });
        },
        getTabState(tab) {
            return this.tabValidationState[tab.tabName];
        },

        navigateToTab(index) {
            if (this.tabs[index].disabled) {
                return;
            }

            this.selectedTab = index;
            this.setSelectedPromotionMaintenanceTab(this.tabs[index].tabName);
            if (this.toggleLogic[enablePromotionPermalink]) {
                this.navigateTo(this.tabs[index]);
            }
        },

        setSelectedTab() {
            if (this.toggleLogic[enablePromotionPermalink]) {
                const tabName = this.$route.params.tabName;
                const tabToOpen = findIndex(this.tabs, { tabName });
                if (tabName && tabToOpen !== -1) {
                    this.selectedTab = tabToOpen;
                    this.setSelectedPromotionMaintenanceTab(tabName);
                } else {
                    const defaultTab = this.tabs.find(tab => tab.isDefault);
                    this.selectedTab = defaultTab ? defaultTab.position : 0;
                    this.setSelectedPromotionMaintenanceTab(defaultTab.tabName);
                }
            }
        },
        setIsActionDisabled(value) {
            this.isActionsDisabled = value;
        },
        openMakeManualConfirmation() {
            this.$refs['make-manual-confirmation-dialog'].open();
        },
        async onPublishingModeBtnCLick() {
            this.isMoveInManualModBtnDisabled = true;
            await this.updatePromoPublishingMode({ promotionId: this.promotion._id });
            this.isMoveInManualModBtnDisabled = false;
        },

        async onMakeStandardPromotionBtnClick() {
            this.makeStandardInProgress = true;
            await this.updatePromotion({
                id: this.namespace,
                updates: {
                    promotionType: promotionTypes.standard,
                    attributeScope: null,
                },
            });
            this.setStagingAreaFields({
                namespace: this.namespace,
                fieldsToUpdate: [
                    {
                        fieldName: 'promotionType',
                        value: promotionTypes.standard,
                    },
                    {
                        fieldName: 'attributeScope',
                        value: null,
                    },
                ],
            });
            this.makeStandardInProgress = false;
        },

        navigateTo(tab) {
            if (!this.isParkingLotOrSubCampaignTab) {
                navigation.toPromotionTabView({
                    tabName: tab.tabName,
                    promotionId: this.computedNamespace,
                    router: this.$router,
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_mixins.scss';
@import '@style/base/_variables.scss';

.promotion-maintenance {
    // Currently we need here explicit height
    // in some cases we have not enough height of content and after tab changing page is jumping
    // more details in https://owlabs.atlassian.net/browse/PROWEB-873
    min-height: 81rem;
    width: 100%;
    @include flex-row;

    background-color: $promo-white;

    &__content {
        flex-grow: 1;
    }

    &__sidebar {
        flex: 0 0 $health-sidebar-width;
        z-index: $health-sidebar-z-index;
    }

    .promo-tabs {
        &__tab {
            display: flex;
            justify-content: space-between;
            // allow pointer events to show tooltip for disabled tabs
            pointer-events: auto !important;
        }

        .make-standard-btn {
            :deep(.v-btn__content) {
                color: $promo-white !important;
            }
        }
    }

    .non-parkinglot {
        border-bottom: $border-shadow 0.1rem solid;
    }
}

.footer {
    display: flex;
    align-items: center;
    padding: 2rem;
    &__execution {
        flex: 50%;
        float: left;
        text-align: left;
    }
    &__unsaved {
        text-align: center;
    }
    &__forecast-save-container {
        display: flex;
        align-items: center;
        &__spinner {
            margin: 0 1rem;
        }
    }
}
</style>
